import { Container } from '@/components/container';
import { Demo5Content } from '.';
const Demo5Page = () => {
  return <Container>
      <Demo5Content />
    </Container>;
};
export { Demo5Page };